import { combineReducers } from 'redux';

import propertyManagement from './property_management/reducer';
import royaltySchedules from './royalty_schedules/reducer';

const nullReducer = state => state || {};

export default combineReducers({
  isParentCompanyUser: isParentCompanyUser => !!isParentCompanyUser,
  paths: nullReducer,
  propertyManagement,
  royaltySchedules,
});
